import { render, staticRenderFns } from "./TranslateDetail.vue?vue&type=template&id=4cc33236&scoped=true&lang=pug&"
import script from "./TranslateDetail.vue?vue&type=script&lang=ts&"
export * from "./TranslateDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TranslateDetail.vue?vue&type=style&index=0&id=4cc33236&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc33236",
  null
  
)

export default component.exports